export default __webpack_public_path__ + "static/media/Off2.f2d364b6.svg";